import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Zap } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    if (password !== confirm) return setError("Passwords do not match");
    if (!token) return setError("Missing reset token");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — you can sign in now");
      nav("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-[700px] items-center px-6 py-12">
      <div className="w-full border border-[#222] bg-[#0A0A0B] p-10">
        <Link to="/" className="font-display text-3xl tracking-widest">
          <span className="text-[#FF003C]">V</span>OLT<span className="text-[#FFE800]">.</span>MV
        </Link>
        <div className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-[#FFE800]">// NEW PASSWORD</div>
        <h1 className="mt-2 font-display text-5xl leading-none">Set Password</h1>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="reset-form">
          <Field label="New password (min 6)">
            <input
              data-testid="reset-password"
              type="password"
              minLength={6}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-[#222] bg-[#050505] p-3 font-mono text-sm text-white outline-none focus:border-[#FF003C]"
            />
          </Field>
          <Field label="Confirm password">
            <input
              data-testid="reset-confirm"
              type="password"
              minLength={6}
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full border border-[#222] bg-[#050505] p-3 font-mono text-sm text-white outline-none focus:border-[#FF003C]"
            />
          </Field>
          {error && (
            <div className="border border-[#FF003C] p-3 font-mono text-xs text-[#FF003C]" data-testid="reset-error">
              {error}
            </div>
          )}
          <button data-testid="reset-submit" type="submit" disabled={loading} className="btn-brutal w-full">
            {loading ? <Loader2 className="animate-spin" size={16} /> : <Zap size={16} />}
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="mb-1 font-mono text-[10px] uppercase tracking-widest text-[#808080]">{label}</div>
      {children}
    </label>
  );
}
